import {AppService} from "../app/app.service";
import {PageResponse} from "../util/page-response";
import {Line} from "./line";

class LineService {

    static API_URL = "/api/lines/v2";

    static findAll = (page?: number, size?: number, sort?: string, filter?: string): Promise<PageResponse<Line>> => {
        return AppService.getAuthorized(this.API_URL, {
            page: page,
            size: size,
            sort: sort,
            id: sort?.startsWith('id') ? filter : '',
            description: sort?.startsWith('description') ? filter : ''
        }).then((result) => {
            return result.data;
        }).catch(() => {
            return {
                content: [],
                totalElements: 0
            };
        })
    };

    static findOne(id: number) {
        return AppService.getAuthorized(this.API_URL + "/" + id).then((result) => {
            return result.data;
        }).catch(() => {
            return null;
        })
    }

    static save(item: Line) {
        if (item.id) {
            return AppService.postAuthorized(this.API_URL + "/" + item.id, item);
        } else {
            return AppService.postAuthorized(this.API_URL, item);
        }
    }

    static delete(id: number) {
        return AppService.deleteAuthorized(this.API_URL + "/" + id);
    }

    static createLine() {
        const line: Line = {
            description: ''
        };
        return line;
    }

}

export {LineService};